import React, { useMemo, useCallback } from 'react';
import { years } from '../../helpers';
import './ToolbarFilterYears.less';

const YEARS_DEFAULT = years;

export default function ToolbarYears(props) {
  const years = useMemo(() => props.years || YEARS_DEFAULT, [props.years]);
  const handleChange = useCallback(
    (e) => {
      const yearValue = parseInt(e.target.value);
      if (props.selectedYears.includes(yearValue)) {
        props.onChange(props.selectedYears.filter((item) => item !== yearValue));
      } else {
        props.onChange([...props.selectedYears, yearValue].sort());
      }
    },
    [],
  );
  return (
    <div className="year-checkboxes">
      {years.map((year, i) => (
        <label key={year}>
          <input
            type="checkbox"
            value={year}
            onChange={handleChange}
            checked={props.selectedYears.includes(year)}
          />
          <span className="tag">{year}</span>
        </label>
      ))}
    </div>
  );
}
